import axiosHttp from "services/axiosHttp";
import PermissionManager from "utils/class/PermissionManager";
import { USER } from "constants/AuthConstant";

/**
 * The courier dispatch queue, served by the backoffice service like everything else on this
 * screen — staff tooling does not call the storefront's customer-facing API.
 *
 * Uses axiosHttp, as every other call on these screens does: the stored token carries no "Bearer"
 * prefix, so that client adds it and refreshes an expired one. FetchInterceptor sends the raw
 * token, which this API rejects, and then signs the operator out on the 401.
 *
 * Retry and Resolve only move a job between states. The courier call itself belongs to the online
 * channel's dispatcher, which owns the one request that can create a parcel; this keeps a single
 * place capable of booking, so an operator clicking twice cannot produce two parcels.
 */
const ONLINE_CHANNEL_CODE = process.env.REACT_APP_ONLINE_CHANNEL_CODE || "CH-000049";

/** The OrelBuy channel is the only one that ships by courier from here. */
export const isOnlineChannel = () => {
	const channel = PermissionManager.getItem(USER)?.channel;
	if (!channel) return false;
	if (channel.code) return channel.code.trim().toUpperCase() === ONLINE_CHANNEL_CODE.toUpperCase();
	return channel.name?.trim().toLowerCase() === "orelbuy";
};

export const DELIVERY_STATES = {
	attention: "Needs attention",
	pending: "Not booked",
	in_flight: "Booking now",
	booked: "Booked",
	unknown: "Unknown outcome",
	failed: "Failed",
	all: "All",
};

export const fetchDeliveries = (state = "attention") => axiosHttp.get("/deliveries", { params: { state } }).then((r) => r.data);

export const retryDelivery = (code) => axiosHttp.post(`/deliveries/${encodeURIComponent(code)}/retry`).then((r) => r.data);

/**
 * Attach the waybill the courier's portal shows for an order, or pass nothing to clear the hold
 * so it can be booked afresh.
 */
export const resolveDelivery = (code, waybillNo) =>
	axiosHttp.post(`/deliveries/${encodeURIComponent(code)}/resolve`, waybillNo ? { waybill_no: waybillNo } : {}).then((r) => r.data);
